module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.form !== null) ? _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('image-control', {
    attrs: {
      "image-id": _vm.form.image_id
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.image_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "image_id", $$v)
      },
      expression: "form.image_id"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "select",
      "id": "company",
      "label": "Show On Company Website</small>",
      "error": _vm.form.errors.get('company'),
      "option_name": 'name',
      "option_value": 'value',
      "options": [{
          name: 'All Companies',
          value: ''
        },
        {
          name: 'Crockett',
          value: 'CF'
        },
        {
          name: 'Bells',
          value: 'BELLS'
        } ]
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.company),
      callback: function($$v) {
        _vm.$set(_vm.form, "company", $$v)
      },
      expression: "form.company"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "id": "name",
      "label": "Page name <small><em>(shown in links to this page)</em></small>",
      "error": _vm.form.errors.get('name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "id": "title",
      "label": "Page title <small><em>(shown on the page and in the browser title)</em></small>",
      "error": _vm.form.errors.get('title')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "id": "slug",
      "label": "Page slug <small><em>(the page URL, tell Andy when changing)</em></small>",
      "error": _vm.form.errors.get('slug')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.slug),
      callback: function($$v) {
        _vm.$set(_vm.form, "slug", $$v)
      },
      expression: "form.slug"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "id": "keywords",
      "label": "Page keywords <small><em>(for SEO, google searches, etc)</em></small>",
      "error": _vm.form.errors.get('keywords')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.keywords),
      callback: function($$v) {
        _vm.$set(_vm.form, "keywords", $$v)
      },
      expression: "form.keywords"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "textarea",
      "id": "description",
      "label": "Page description <small><em>(for SEO)</em></small>",
      "error": _vm.form.errors.get('description')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "checkbox",
      "id": "enabled",
      "label": "List page on frontend",
      "error": _vm.form.errors.get('enabled')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.enabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "enabled", $$v)
      },
      expression: "form.enabled"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.apiBusy
    },
    on: {
      "click": function($event) {
        return _vm.updatePage()
      }
    }
  }, [_vm._v("\n        Save Page Details\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-8"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.contents), function(content) {
    return _c('page-content', {
      key: content.id,
      attrs: {
        "content": content
      }
    })
  }), _vm._v(" "), _c('page-content', {
    attrs: {
      "page-id": parseInt(_vm.$route.params.id)
    }
  })], 2)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("\n        Page Contents\n        "), _c('br'), _vm._v(" "), _c('small', [_vm._v("(updates automatically)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d9ed507"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/pages/PageEdit.vue
// module id = 533
// module chunks = 0